import { Pipe, PipeTransform } from '@angular/core';

/** True when a leak field has nothing to show (empty string, empty array, null). */
export function isBlankLeakValue(value: unknown): boolean {
  if (value == null) {
    return true;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed === '' || trimmed === ',';
  }
  if (Array.isArray(value)) {
    return value.length === 0 || value.every((item) => isBlankLeakValue(item));
  }
  if (typeof value === 'object') {
    return Object.keys(value as object).length === 0;
  }
  return false;
}

@Pipe({
  name: 'leakFieldBlank',
  standalone: true,
})
export class LeakFieldBlankPipe implements PipeTransform {
  transform(value: unknown): boolean {
    return isBlankLeakValue(value);
  }
}

/**
 * When a leak field holds more than one comma-separated value (or an array),
 * return those values for a bullet list. Address and about stay a single block of text.
 * A single value returns null so the field stays plain text.
 */
@Pipe({
  name: 'leakEmailItems',
  standalone: true,
})
export class LeakEmailItemsPipe implements PipeTransform {
  transform(value: unknown, key: unknown): string[] | null {
    const keyStr = String(key ?? '').toLowerCase();
    if (
      keyStr.startsWith('address') ||
      keyStr === 'about' ||
      keyStr.startsWith('about_')
    ) {
      return null;
    }

    const items = splitListValues(value);
    return items.length > 1 ? items : null;
  }
}

function splitListValues(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.flatMap((item) => splitListValues(item));
  }
  if (typeof value !== 'string') {
    return [];
  }
  return value
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}
